'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:QuotationServiceCtrl
 * @description
 * # QuotationCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Quotation', ['$http', 'domain', 'BaseService', 'toaster', function($http, domain, BaseService, toaster) {
    var BASE_QUOTATION_URL = domain.name + '/api/v1/quotations/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_QUOTATION_URL,
      baseModelName: 'quotation'
    });

    baseService.aasm_transition = function(params) {
      return $http.post(BASE_QUOTATION_URL + params.quotation.id + '/aasm_transition', params);
    };

    baseService.getStates = () => {
      return $http.get(`${domain.name}/api/v1/quotation_states`);
    };

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if('contact_name' in error.data.errors) {
          toaster.pop('error', 'Nombre', 'El nombre del contacto ' + error.data.errors.contact_name);
        }
        if('name' in error.data.errors) {
          toaster.pop('error', 'Prospecto', 'El prospecto ' + error.data.errors.name);
        }
        if('drive_root_url' in error.data.errors) {
          toaster.pop('error', 'Url', 'Favor de verificar la ruta del prospecto.');
        }
        if('product_catalog' in error.data.errors) {
          toaster.pop('error', 'Producto', 'El producto ' + error.data.errors.product_catalog_id);
        }
        if('prospect' in error.data.errors) {
          toaster.pop('error', 'Prospecto', error.data.errors.prospect[0]);
        }
        if('audit_comment' in error.data.errors) {
          toaster.pop('error', 'Comentario', 'El comentario ' + error.data.errors.audit_comment);
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
